export default __webpack_public_path__ + "static/media/4.ccd6d7f2.png";